import { Pipe, PipeTransform } from '@angular/core';

/**
 * Replaces several characters line `\n` (for new line) with the corresponding html tag `<br>`
 *
 * 🙀 👉 IN CARL MAKE SURE that the text where you are using `\n` is wrapped within double quotes `"Working\nText"`, NOT single quotes `'Wont\nWork'`
 */
@Pipe({
  name: 'nl2br',
  standalone: true
})
export class Nl2brPipe implements PipeTransform {
  public transform(text: string): string {
    return text.replaceAll(/(\r\n|\n\r|\r|\n)/g, '<br>');
  }
}
